import styles from "./styles.module.scss";
import Link from "next/link";
import Image from "next/image";
import ConvertionImg from "../../../public/static-next/convertion.svg";

export const IndiceFnz = () => {
  return (
    <Link href="/indice-de-emprestimo/" passHref>
      <div className={styles.cta}>
        <div className={styles.column}>
          <div className={styles.align}>
            <ConvertionImg />
            <div className={styles.column}>
              <h3>Índice FinanZero de Empréstimos no Brasil</h3>
            </div>
          </div>
        </div>
        <div className={styles.columnImage}>
          <Image
            width={170}
            height={220}
            alt="Simule emprestimo Finanzero"
            src="/static-next/banner-conversion-celular.png"
          />
        </div>
      </div>
    </Link>
  );
};
